import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { ActivationCodeGenerateInput, Classify, CommonImportAgrs, CommonImportFileResponse, CreateOrEditActivationCodeInput, CreateOrEditChallengeFollowInput, CreateOrEditChallengeFollowResponse, CreateOrEditChallengeInput, CreateOrEditChallengeResponse, CreateOrEditOutletInfoDto, GetActivationCodeInput, GetAllRetailerUpdatePhoneInput, GetChallengeHeaderForEditResponse, GetOutletInfoForEditOutput, GetRankTypeForEditOutput, OutletInfosImportAgrs, PagedResultDtoOfGetActivationCodeForViewDto, PagedResultDtoOfGetChannelTypeForView, PagedResultDtoOfGetDeparmentForView, PagedResultDtoOfGetListChallengeFollowForEditResponse, PagedResultDtoOfGetListChallengeHeaderResponse, PagedResultDtoOfGetListChallengeResultForEditResponse, PagedResultDtoOfGetProductForView, PagedResultDtoOfGetRankTypeForView, PagedResultDtoOfGetSalesmanForViewDto, PagedResultDtoOfGetSAPSerialForViewDto, PagedResultDtoOfOutletInfoUpdateHistoryDto, ResponseDtoOfBoolean, ResponseDtoOfListOfListOfSerialProducer, SocialRetailerFileDto, StatusImportDistributeDto } from '@shared/service-proxies/service-proxies';
import { PagedResultDtoOfGetOutletInfoForViewDto } from '@shared/service-proxies/service-proxies';
import { API_ENDPOINTS } from '@shared/APIEndpoint';
import * as moment from "moment";
import { HttpParams } from '@angular/common/http';
import { BaseApiService } from './base-api-service';
import { AppConsts } from '@shared/AppConsts';

@Injectable({ providedIn: 'root' })
export class MDActivationCodeService extends BaseApiService {
  protected prefix = AppConsts.MDPrefix;

  constructor(api: ApiService) {
    super(api);
  }

  getAll(
    code?: string,
    serial?: string,
    status?: string,
    massOrder?: string,
    importDate?: moment.Moment,
    activeDate?: moment.Moment,
    isCancel?: boolean,
    note?: string,
    salemanCode?: string,
    fromDate?: moment.Moment,
    toDate?: moment.Moment,
    sorting?: string,
    skipCount?: number,
    maxResultCount?: number
  ): Observable<PagedResultDtoOfGetActivationCodeForViewDto> {

    let params = new HttpParams();

    const url = API_ENDPOINTS.MD.ActivationCode.GetAll;

    if (code != null) params = params.set('Code', code);
    if (serial != null) params = params.set('Serial', serial);
    if (status != null) params = params.set('Status', status);
    if (massOrder != null) params = params.set('MassOrder', massOrder);

    if (importDate != null)
      params = params.set('ImportDate', importDate.toJSON());

    if (activeDate != null)
      params = params.set('ActiveDate', activeDate.toJSON());

    if (isCancel != null)
      params = params.set('IsCancel', isCancel.toString());

    if (note != null) params = params.set('Note', note);
    if (salemanCode != null) params = params.set('SalemanCode', salemanCode);

    if (fromDate != null)
      params = params.set('FromDate', fromDate.toJSON());

    if (toDate != null)
      params = params.set('ToDate', toDate.toJSON());

    if (sorting != null) params = params.set('Sorting', sorting);
    if (skipCount != null) params = params.set('SkipCount', skipCount.toString());
    if (maxResultCount != null) params = params.set('MaxResultCount', maxResultCount.toString());

    return this.get<PagedResultDtoOfGetActivationCodeForViewDto>(
      url,
      params
    );
  }

  createOrEdit(
    input?: CreateOrEditActivationCodeInput
  ): Observable<void> {

    const url = API_ENDPOINTS.MD.ActivationCode.CreateOrEdit;

    return this.post<void>(
      url,
      input
    );
  }

  exportFile(
    input?: GetActivationCodeInput
  ): Observable<SocialRetailerFileDto> {

    const url = API_ENDPOINTS.MD.ActivationCode.ExportFile;

    return this.post<SocialRetailerFileDto>(
      url,
      input
    );
  }

  importActiveCodeInsert(
    arg?: CommonImportAgrs
  ): Observable<StatusImportDistributeDto> {

    const url = API_ENDPOINTS.MD.ActivationCode.ImportActiveCodeInsert;

    return this.post<StatusImportDistributeDto>(
      url,
      arg
    );
  }

  importActiveCodeUpdate(
    arg?: CommonImportAgrs
  ): Observable<StatusImportDistributeDto> {

    const url = API_ENDPOINTS.MD.ActivationCode.ImportActiveCodeUpdate;

    return this.post<StatusImportDistributeDto>(
      url,
      arg
    );
  }

  downloadTempFile(
    fileName?: string,
    fileType?: string,
    fileToken?: string
  ): Observable<Blob> {
    const url = API_ENDPOINTS.File.DownloadTempFile;

    let params = new HttpParams();
    if (fileName != null) params = params.set("FileName", fileName);
    if (fileType != null) params = params.set("FileType", fileType);
    if (fileToken != null) params = params.set("FileToken", fileToken);

    return this.getBlob(url, params);
  }

}
